<template>
  <div>
    <div class="card-body py-0 mt-n2 mb-3 d-flex align-items-center justify-content-end padding">
      <a href="https://consola-v2.canplast.net/docs-venta/orden-recoleccion" target="_blank" text-decoration="none" class="text-white mr-2">
        <base-button size="sm" icon="fa fa-search">
            Manifiesto Paquetexpress
        </base-button>
      </a>
      <base-button @click="modals.docHistory = true" size="sm" icon="fa fa-search">
        Doc. relacionados
      </base-button>
    </div>
    <ag-grid-vue
      style="height: 70vh;"
      class="ag-theme-alpine mb-4"
      v-bind="agDeliveries"
      @cell-clicked="onCellClicked"
      @row-double-clicked="onRowDoubleClicked"
    />
    <modal :show.sync="modals.docHistory" modal-classes="modal-dialog-centered modal-md">
      <SearchDocHistory v-if="modals.docHistory"/>
    </modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import AgGrid from "@/mixins/AgGrid.js";
import Formats from "@/mixins/Formats.js";
import axios from "axios";
import moment from "moment";
import AgBadge from "@/components/AgGrid/AgBadge.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import CustomerAddress from "@/components/AgGrid/CustomerAddress.vue";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import warehouses from "@/data/warehouses.json";
import SearchDocHistory from "../SearchDocHistory.vue";

export default {
  mixins: [AgGrid, Formats],
  components: {
    AgGridVue,
    AgBadge,
    BaseLoader,
    CustomerAddress,
    agDateInput: FilterDate,
    SearchDocHistory,

  },
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASE_URL,
      HANA_URL: process.env.VUE_APP_HANA_URL,
      user: null,
      salesPersonOptions: [],
      modals: {
        docHistory: false,
      },
      agDeliveries: {
        rowData: null,
        columnDefs: [
          { 
            field: "DocNum", 
            headerName: "# Entrega",
            filter: "agTextColumnFilter",
						cellClass: "ag-clickable-cell text-blue font-weight-bold",
            width: 90,
          },
          {
            field: "customer", 
            headerName: "Cliente", 
            filter: "agTextColumnFilter",
            width: 300,
            cellRenderer: function ({data}) {
              return `
                <span>
                  <span class="font-weight-bold">${data.CardName}</span>
                  <span class="font-weight-normal">${data.CardCode}</span>
                </span>
              `;
            }
          },
          {
            field: "DocDate",
            headerName: "Fecha",
            filter: "agDateColumnFilter",
            width: 80,            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          {
            field: "DocDueDate",
            headerName: "Vencimiento",
            width: 100,
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          { 
            field: "U_Warehouse", 
            headerName: "Almacén",
            width: 80,
            filter: "agSetColumnFilter",
            filterParams: {
              values: warehouses,
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            }
          },
          { 
            field: "SalesPerson", 
            headerName: "Vendedor",
            width: 120,
            filter: "agSetColumnFilter",
            filterParams: {
              values: (params) => params.success(this.salesPersonOptions.map((x) => x.SalesEmployeeName)),
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            }
          },
          {
            field: "DocTotal",
            headerName: "Total",
            width: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({data}) => this.currencyFormat(data.DocTotal, data.DocCur),
            headerClass: "ag-right-aligned-header",
            type: "rightAligned",
          },
          {
            field: "DocStatus",
            headerName: "Estatus",
            width: 80,
            cellClass: "d-flex justify-content-center",
            filter: "agSetColumnFilter",
            filterParams: {
              values: ['O'],
              valueFormatter: ({value}) => (value === "O" ? "Abierta" : "Cerrada"),
            },
						sortable: false,
            cellRendererSelector: ({value}) => {
              return {
                component: "AgBadge",
                params: {
                  text: value === "O" ? "Abierta" : "Cerrada",
                  color: value === "O" ? "#5e72e4" : "#adb5bd",
                },
              };
            },
          },
          {
            field: "Comments",
            headerName: "Comentarios",
            width: 500,
            filter: "agTextColumnFilter",
          },
          {
            field: "Address2", 
            headerName: "Dirección", 
            width: 600,
            filter: "agTextColumnFilter",
            cellRenderer: function ({data}) {
              return `
                <span>
                  <span class="font-weight-bold">${data.ShipToCode}</span>
                  <span class="font-weight-normal">${data.Address2}</span>
                </span>
              `;
            }
          },
        ],
        defaultColDef: {
          menuTabs: ["filterMenuTab"],
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          floatingFilter: true,
          suppressFloatingFilterButton: true,

        },
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        cacheQuickFilter: true,
        pagination: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
        rowSelection: "single",
      },
    };
  },
  methods: {
    getDeliveries() {
      const deliveriesJson = {
        // select: `*`,
        select: `"CardCode", "DocNum",  "DocEntry", "DocDate", "DocDueDate", "CardName", "DocTotalSy", "DocTotalFC", "SlpCode", "DocStatus", "U_Warehouse", "DocCur", "ShipToCode", "Address2", "Comments"`,
        table: "ODLN",
        where: `WHERE CANCELED != 'Y' AND "DocStatus" = 'O' ORDER BY "DocNum" DESC`,
      };
      axios
        .post(`${this.HANA_URL}/api/hana/basic_general_query`, deliveriesJson)
        .then((res) => {
          this.agDeliveries.rowData = res.data.map((x) => {
            return {
              DocEntry: parseInt.DocEntry,
              DocNum: x.DocNum,
              customer: x.CardName + " " + x.CardCode,
              CardName: x.CardName,
              CardCode: x.CardCode,
              DocDate: moment(x.DocDate).format("YYYY-MM-DD"),
              DocDueDate: moment(x.DocDueDate).format("YYYY-MM-DD"),
              DocTotal: parseFloat(x.DocCur === 'MXP' ? x.DocTotalSy : x.DocTotalFC),
              SalesPerson: this.salesPersonOptions.find((y) => y.SalesEmployeeCode === x.SlpCode).SalesEmployeeName,
              DocStatus: x.DocStatus,
              U_Warehouse: x.U_Warehouse,
              DocCur: x.DocCur,
              ShipToCode: x.ShipToCode,
              Address2: x.Address2,
              Comments: x.Comments,
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onRowDoubleClicked({data}) {
      this.$router.push("/delivery/" + data.DocNum);
    },
    onCellClicked({data, colDef}) {
      if (colDef.field === "DocNum") {
        this.$router.push("/delivery/" + data.DocNum);
      }
    },
  },
  created() {
    axios
      .get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
        this.getDeliveries();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
